module.exports = __webpack_public_path__ + "img/edifici_amicbici_in_process.11626560.svg";